import React from 'react'
import Dotted from '../Assets/dotted bg.png';
import Ellipse from '../Assets/Ellipse 31.png';
import Cube from '../Assets/cube.png'
import Lottie from 'lottie-react';
import staticBg from '../Assets/static.json'
import { Fade } from 'react-reveal';
import ReactTyped from 'react-typed';
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-scroll';

const HeroSection = () => {

    const Navigate = useNavigate()

  return (
    <div className='w-[80%] mx-auto h-screen relative'>
        <div className='text-[#fff]  relative text-left flex flex-col'>

            <Fade top distance='20%' duration='1500'>
                <p className='text-[6rem] z-50  font-normal leading-[6rem] mt-10 mb-8 clashDisplay mainHeading'>
                    Treble(3x) the <br/>
                    <span className=' font-medium mainHeadingSpan skConcretica'>
                        <ReactTyped 
                            strings={['Brand Value','Impact','Market Presence','ROI','Profits','Customer Experience']}
                            typeSpeed={80}
                            backSpeed={80}
                            backDelay={1000}
                            loop
                        />
                    </span>
                </p>
                <p className='w-[400px] text-[1.1rem] leading-[35px] font-normal dmSans headPara'>
                    We, the digital geeks, pave perfect paths for our clients' brands to bloom in the digital realm.
                </p>
            </Fade>

            {/* Button & Links */}
            <div className='flex items-center gap-16 mt-[5rem]'>
                <button onClick={()=>Navigate('/contactus')} className='relative block overflow-hidden bg-[#6343FF] w-[160px] h-[50px] rounded-[8px] heroButton'>
                    <Lottie animationData={staticBg} className=' opacity-10 absolute bottom-0' />
                    Lets chat!!
                </button>
                <div className='flex gap-[35px] heroLinks'>

                    {/* Insta Icon */}
                    {/* eslint-disable-next-line */}
                    <a href='https://www.instagram.com/trebled.in/' target='_blank'>
                        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 34 34" fill="none">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M33.9136 9.99612C33.8339 8.18957 33.5418 6.94757 33.1231 5.87137C32.6913 4.72902 32.0271 3.70626 31.1567 2.85604C30.3062 1.99259 29.2766 1.32164 28.1472 0.896655C27.0646 0.478164 25.8289 0.186021 24.0219 0.106369C22.2015 0.0199773 21.6237 0 17.0067 0C12.3896 0 11.8117 0.0199774 9.99803 0.0996318C8.19113 0.179285 6.9489 0.471675 5.87275 0.889918C4.72992 1.32163 3.70697 1.98584 2.85658 2.85604C1.99297 3.70626 1.32217 4.73575 0.896842 5.86489C0.478271 6.94757 0.186072 8.18281 0.106404 9.98938C0.0199826 11.8094 0 12.3872 0 17.0034C0 21.6196 0.0199826 22.1973 0.0996507 24.0106C0.179319 25.8172 0.471781 27.0592 0.890351 28.1354C1.32217 29.2777 1.99297 30.3004 2.85658 31.1507C3.70697 32.0142 4.73666 32.6851 5.86601 33.1101C6.9489 33.5286 8.18438 33.8208 9.99154 33.9003C11.8049 33.9802 12.3831 34 17.0002 34C21.6172 34 22.1951 33.9802 24.0086 33.9003C25.8156 33.8208 27.0578 33.5286 28.1339 33.1101C30.4193 32.2266 32.2263 30.42 33.11 28.1354C33.5282 27.0527 33.8207 25.8172 33.9003 24.0106C33.9801 22.1973 34 21.6196 34 17.0034C34 12.3872 33.9932 11.8094 33.9136 9.99612ZM30.8511 23.8778C30.778 25.5383 30.4991 26.4349 30.2665 27.0327C29.6951 28.5139 28.5194 29.6895 27.0379 30.2607C26.44 30.4933 25.5366 30.7722 23.8824 30.8451C22.0887 30.925 21.5508 30.9448 17.0133 30.9448C12.476 30.9448 11.9313 30.925 10.1441 30.8451C8.48333 30.7722 7.58649 30.4933 6.9886 30.2607C6.25137 29.9883 5.58031 29.5566 5.03561 28.9921C4.47093 28.4407 4.03913 27.7766 3.76666 27.0394C3.53414 26.4417 3.25517 25.5383 3.18226 23.8845C3.10233 22.0912 3.08261 21.5531 3.08261 17.0166C3.08261 12.4801 3.10233 11.9355 3.18226 10.1489C3.25517 8.48845 3.53414 7.59179 3.76666 6.99402C4.03913 6.25665 4.47093 5.58598 5.04235 5.04112C5.59354 4.47657 6.25785 4.04484 6.99535 3.77267C7.59324 3.5402 8.49682 3.2613 10.1509 3.18814C11.9445 3.10849 12.4827 3.08851 17.0198 3.08851C21.5639 3.08851 22.1019 3.10849 23.889 3.18814C25.5499 3.2613 26.4468 3.5402 27.0445 3.77267C27.7819 4.04484 28.4529 4.47657 28.9977 5.04112C29.5622 5.59247 29.994 6.25665 30.2665 6.99402C30.4991 7.59179 30.778 8.49494 30.8511 10.1489C30.9309 11.9423 30.9508 12.4801 30.9508 17.0166C30.9508 21.5531 30.9309 22.0845 30.8511 23.8778ZM17.0065 8.26922C12.1837 8.26922 8.27071 12.1812 8.27071 17.0034C8.27071 21.8256 12.1837 25.7376 17.0065 25.7376C21.8296 25.7376 25.7423 21.8256 25.7423 17.0034C25.7423 12.1812 21.8296 8.26922 17.0065 8.26922ZM17.0065 22.6691C13.8777 22.6691 11.3398 20.1319 11.3398 17.0034C11.3398 13.8749 13.8777 11.3377 17.0065 11.3377C20.1356 11.3377 22.6732 13.8749 22.6732 17.0034C22.6732 20.1319 20.1356 22.6691 17.0065 22.6691ZM26.0879 9.96283C27.2144 9.96283 28.1276 9.04983 28.1276 7.92381C28.1276 6.79753 27.2144 5.88478 26.0879 5.88478C24.9617 5.88478 24.0485 6.79753 24.0485 7.92381C24.0485 9.04983 24.9617 9.96283 26.0879 9.96283Z" fill="white"/>
                        </svg>
                    </a>

                    {/* Facebook Icon */}
                    <a href='https://www.facebook.com/trebled.in?mibextid=ZbWKwL' target='_blank' rel='noreferrer' className=' z-50'>
                        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 33 33" fill="none">
                            <path d="M33 16.6001C32.9997 13.4274 32.0958 10.3213 30.3954 7.64948C28.6952 4.97765 26.2696 2.85195 23.4059 1.52409C20.5422 0.196208 17.3603 -0.278239 14.237 0.156906C11.1136 0.592034 8.17957 1.91855 5.78221 3.97938C3.38484 6.04021 1.62455 8.74905 0.709717 11.7852C-0.205111 14.8214 -0.23616 18.0577 0.620245 21.1111C1.47665 24.1644 3.18466 26.9071 5.54204 29.014C7.8994 31.121 10.8074 32.5044 13.9219 33V21.3994H9.73226V16.6001H13.9219V12.9421C13.9219 8.78191 16.3859 6.48253 20.1534 6.48253C21.3911 6.5004 22.6258 6.60859 23.8481 6.80627V10.8931H21.7663C21.1396 10.8094 20.5055 10.9796 20.0036 11.3661C19.5014 11.7527 19.1727 12.324 19.0891 12.9545C19.0655 13.1311 19.0618 13.3098 19.0782 13.4872V16.6001H23.6501L22.9185 21.3994H19.0684V33C22.9515 32.3843 26.4886 30.394 29.0426 27.3873C31.5968 24.3806 33.0002 20.5553 33 16.6001Z" fill="white"/>
                        </svg>
                    </a>

                    {/* LinkedIn Icon */}
                    {/* eslint-disable-next-line */}
                    <a href='https://www.linkedin.com/company/trebled/' target='_blank' className=' z-50'>
                        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 34 34" fill="none">
                            <g clip-path="url(#clip0_1_64)">
                                <path d="M33.9915 34.0001L34 33.9987V21.5292C34 15.4291 32.6868 10.73 25.5553 10.73C22.127 10.73 19.8263 12.6113 18.887 14.3949H18.7879V11.2995H12.0261V33.9987H19.067V22.7589C19.067 19.7995 19.628 16.9378 23.2929 16.9378C26.904 16.9378 26.9578 20.3151 26.9578 22.9487V34.0001H33.9915Z" fill="white"/>
                                <path d="M0.561035 11.3008H7.61037V34H0.561035V11.3008Z" fill="white"/>
                                <path d="M4.08283 0C1.82892 0 0 1.82892 0 4.08283C0 6.33675 1.82892 8.20392 4.08283 8.20392C6.33675 8.20392 8.16567 6.33675 8.16567 4.08283C8.16425 1.82892 6.33533 0 4.08283 0Z" fill="white"/>
                            </g>
                            <defs>
                                <clipPath id="clip0_1_64">
                                <rect width="34" height="34" fill="white"/>
                                </clipPath>
                            </defs>
                        </svg>
                    </a>
                </div>
            </div>

            {/* Background */}
            <div className='absolute -top-[0rem] -right-[25rem] mainEllipse1'>
                <img src={Ellipse} alt='' width='75%'/>
            </div>
            <div className='absolute -top-[10rem] -right-[15rem] mainEllipse2'>
                <img src={Ellipse} alt='' width='80%'/>
            </div>

            {/* Dotted */}
            <div className='absolute top-[7.5rem] -right-[28rem] mainDotted'>
                <img src={Dotted} alt='' width='75%'/>
            </div>
            {/* Cube */}
            <div className='hero-cube'>
                <img src={Cube} alt='' width='75%'/>
            </div>   
                
        </div>

        {/* Side Text */}
        <div className='absolute -right-3 text-[#fff]'>
            <p className=' text-right text-[3rem] leading-[3.5rem] uppercase sideText'>
                Design <br/>
                Function <br/>
                Form
            </p>
        </div>  

        {/* Arrow */}
        <Link to='visibleWork' className='cursor-pointer' smooth={true} duration={1000} offset={-70}>
            <div className=' absolute top-0 right-0  flex-col items-end gap-4 mainArrow flex'>
                
                <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 69 69" fill="none">
                    <path d="M56.3123 8.8653L65.918 8.8653L65.918 60.0555C65.918 62.7081 63.7675 64.8584 61.1151 64.8584L9.92482 64.8584L9.92482 55.2527L49.1735 55.2527L3.69145 9.77058L10.4837 2.97822L56.3123 48.807L56.3123 8.8653Z" fill="#FFCC2E"/>
                </svg>
            
                <p className='text-[#fff] text-right text-[1rem] z-[100]'>Latest Projects</p>
                
            </div>
        </Link>
        
        
    </div>
  )
}

export default HeroSection